import { render, staticRenderFns } from "./TopicsInsightsDepTable.vue?vue&type=template&id=4c453296&"
import script from "./TopicsInsightsDepTable.vue?vue&type=script&lang=js&"
export * from "./TopicsInsightsDepTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports